'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const ex=require('pulsar-utils/dist-es6/ex');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const Group=require('../../../../../../dist-es6/shared/domain/group');let

GroupsNotificationSettingsSubviewDirective=class GroupsNotificationSettingsSubviewDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'emailAddress'];

}

get templateUrl(){
return'/templates/features/notificationSettings/components/groupsNotificationSettingsSubviewDirective/groupsNotificationSettingsSubviewTemplate';
}

get controller(){
return GroupsNotificationSettingsSubviewDirectiveController;
}};let


GroupsNotificationSettingsSubviewDirectiveController=(_class=class GroupsNotificationSettingsSubviewDirectiveController extends BaseController{
static get $inject(){
return[
'$timeout',
'$modal',
'uncaughtErrorHandler',
'socketService',
'notificationService',
'groupsCommandAndQueryService',
'organizationDefaultsService',
'Analytics',
'uiCommandFactory'];

}

constructor($timeout,
$modal,
uncaughtErrorHandler,
socketService,
notificationService,
groupsCommandAndQueryService,
organizationDefaultsService,
Analytics,
uiCommandFactory){
super(uncaughtErrorHandler);

this._$timeout=$timeout;
this._$modal=$modal;
this._socketService=socketService;
this._groupsCommandAndQueryService=groupsCommandAndQueryService;
this._organizationDefaultsService=organizationDefaultsService;
this._notificationService=notificationService;
this._analytics=Analytics;
this._uiCommandFactory=uiCommandFactory;

this._reloadSettings=this._reloadSettings.bind(this);

this._controllerInitialized=!1;

this.groups=[];

this._reloadSettings();
}


async _reloadSettings(){
let notificationSettingsResponse=await this._socketService.sendAndWaitForResponse('GetNotificationSettings');
if(!SocketResponse.succeeded(notificationSettingsResponse)){
this._notificationService.displayNotification('Failed to retrieve notification settings.','error');
return;
}

await this._makeViewModelsFromLatestSettings(notificationSettingsResponse.body);
}


async _onNotificationsEnabledForGroupChanging(groupId,newIsChecked){
let messageName=newIsChecked?'EnableGroupNotifications':'DisableGroupNotifications';
let socketResponse=await this._socketService.sendAndWaitForResponse(messageName,groupId);

await this._handleErrorsReloadSettingsAndTrackForAnalytics(socketResponse,{
category:'ChangeUserSetting',
action:messageName,
label:`id=${groupId}`});

}


async _onNotificationTypeForGroupChanging(groupId,groupNotificationType){
let requestBody={groupId,groupNotificationType};
let socketResponse=await this._socketService.sendAndWaitForResponse('SetGroupNotificationType',requestBody);

await this._handleErrorsReloadSettingsAndTrackForAnalytics(socketResponse,{
category:'ChangeUserSetting',
action:'SetGroupNotificationType',
label:`type=${groupNotificationType.name}|id=${groupId}`});


}

async _handleErrorsReloadSettingsAndTrackForAnalytics(socketResponse,analyticsEventInfo){
if(!SocketResponse.succeeded(socketResponse)){
if(socketResponse.status==='NotificationSettingsUpdateFailed'){
this._notificationService.displayNotification('Unable to update notification settings at this time. Please try again.','warning');
}else{
this._notificationService.displayNotification('An unexpected occurred updating notification settings. Please try again','error');
}
await this._reloadSettings();
return;
}

await this._makeViewModelsFromLatestSettings(socketResponse.body);

this._analytics.trackEvent(analyticsEventInfo.category,analyticsEventInfo.action,analyticsEventInfo.label);
}

_disposeCommands(){
if(_.exists(this.groups)&&this.groups.length>0){
this.groups.forEach(group=>{
group.notificationsEnabledChangedCommand.dispose();
group.notificationTypeChangedCommand.dispose();
});
}
}

_setThresholdFor(group,defaultThresholds){
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/setThresholdModalView',
controller:'SetThresholdModalController as controller',
resolve:{
resolvedParameters:()=>{
return{
defaultFatigueThreshold:defaultThresholds.fatigueThreshold,
defaultDeviationThreshold:defaultThresholds.deviationThreshold,
group:group,
onThresholdSet:this._reloadSettings};

}}});



return modalInstance;
}

async _makeViewModelsFromLatestSettings(notificationSettings){
let defaultThresholds=await this._organizationDefaultsService.getOrganizationThresholds();
let groupsWithThresholds=await this._groupsCommandAndQueryService.getFlattenedGroups();
if(groupsWithThresholds.length===0){
groupsWithThresholds=[Group.getFakeOrgGroup(defaultThresholds)];
}
let groupsWithThresholdsById=_.keyBy(groupsWithThresholds,'id');
let groupsGroupedByParentId=_.groupBy(groupsWithThresholds,'parentId');

let oldGroupsById=_.keyBy(this.groups,'id');
for(let group of notificationSettings.groupsSettings){
let existingGroup=oldGroupsById[group.id];
if(_.exists(existingGroup)){
group.notificationsEnabledChangedCommand=existingGroup.notificationsEnabledChangedCommand;
group.notificationTypeChangedCommand=existingGroup.notificationTypeChangedCommand;
}else{
group.notificationsEnabledChangedCommand=this._uiCommandFactory.make(newIsChecked=>this._onNotificationsEnabledForGroupChanging(group.id,newIsChecked));
group.notificationTypeChangedCommand=this._uiCommandFactory.make(newType=>this._onNotificationTypeForGroupChanging(group.id,newType));
}

group.fatigueThreshold=ex(_.get(groupsWithThresholdsById,`${group.id}.fatigueThreshold`)).
otherwise(defaultThresholds.fatigueThreshold);

group.deviationThreshold=ex(_.get(groupsWithThresholdsById,`${group.id}.deviationThreshold`)).
otherwise(defaultThresholds.deviationThreshold);

group.setThreshold=()=>this._setThresholdFor(group,defaultThresholds);

group.displayInList=groupsWithThresholdsById[group.id].personIds.length>0||!_.exists(groupsGroupedByParentId[group.id]);

const parentGroupNames=_getParentGroupNames(groupsWithThresholdsById[group.id],groupsWithThresholdsById);
group.fullDisplayName=_.concat(parentGroupNames,groupsWithThresholdsById[group.id].name).join(' > ');
}

this._$timeout(()=>{
this.groups=_.sortBy(notificationSettings.groupsSettings,['fullDisplayName']);
this._controllerInitialized=!0;
});
}},(_applyDecoratedDescriptor(_class.prototype,'_reloadSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_reloadSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onNotificationsEnabledForGroupChanging',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onNotificationsEnabledForGroupChanging'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onNotificationTypeForGroupChanging',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onNotificationTypeForGroupChanging'),_class.prototype)),_class);


function _getParentGroupNames(group,groupsById){
const parents=[];

let lastChild=group;
while(lastChild=groupsById[lastChild.parentId]){
parents.push(lastChild);
}

return parents.map(p=>p.name).reverse();

}

module.exports=GroupsNotificationSettingsSubviewDirective;
module.exports.controller=GroupsNotificationSettingsSubviewDirectiveController;
//# sourceMappingURL=groupsNotificationSettingsSubviewDirective.js.map
